import React, { Fragment } from 'react'

import { Button } from '@guillotinaweb/react-gmi'
import { Loading } from '@guillotinaweb/react-gmi'
import { FileUpload } from '@guillotinaweb/react-gmi'

import { I18NRichText, I18NField } from '../../components/i18nfield'
import { Preview } from '../../components/preview'
import { ProductSummary } from '../../components/product'
import { getMediaUrl, TINYMCE_INIT_UNRESTRICTED } from '../../consts'

const isEqual = (a, b) => {
  let result = true
  Object.keys(b).forEach((key) => {
    if (a[key] !== b[key]) result = false
  })
  return result
}

const Empty = () => null

function ImageEditor({ Ctx, modifyContent, field, uploadFieldName }) {
  const [imgLoading, setImgLoading] = React.useState(false)

  const uploadFile = async (file) => {
    // @TODO implement some kind of file validation
    setImgLoading(true)

    const folder = `tags/${Ctx.context.parent['@name']}`
    const resp = await Ctx.client.upload(
      Ctx.path,
      file,
      folder,
      uploadFieldName
    )
    if (resp.status !== 200) {
      Ctx.flash('error_uploading_file', 'danger')
    } else {
      Ctx.flash('Imagen cabecera subida!', 'success')
      Ctx.refresh()
    }
    setImgLoading(false)
  }

  return (
    <Fragment>
      {field && (
        <figure class="image" style={{ width: 300 }}>
          <img src={getMediaUrl() + field} alt="" />
          <a
            href="#"
            className="delete is-medium"
            style={{
              position: 'absolute',
              top: 6,
              right: 6,
              backgroundColor: '#FF0000AA',
            }}
            onClick={async () => {
              const resp = await Ctx.client.deleteFile(
                Ctx.path,
                uploadFieldName
              )
              if (resp.status !== 200) {
                Ctx.flash('error_deleting_file', 'danger')
              } else {
                Ctx.flash('Imagen borrada', 'success')
                Ctx.refresh()
              }
            }}
          ></a>
        </figure>
      )}
      {modifyContent &&
        (!imgLoading ? (
          <FileUpload onChange={uploadFile} accept="image/*" />
        ) : (
          <Loading />
        ))}
    </Fragment>
  )
}

function TagPropView({ Ctx }) {
  const title_text = Ctx.context.title_text || {}
  const localized_text = Ctx.context.localized_text || {}
  const comentario = Ctx.context.comentario || {}

  const [isDirty, setDirty] = React.useState(false)
  const [loading, setLoading] = React.useState(false)
  const [state, setState] = React.useState({ localized_text, comentario })

  const modifyContent = Ctx.hasPerm('guillotina.ModifyContent')

  const onSubmit = async (ev) => {
    ev.preventDefault()
    if (loading) {
      alert('uploading en curso')
      return
    }
    setLoading(true)
    const result = await Ctx.client.patch(Ctx.path, state)
    if (result.status === 204) {
      Ctx.flash('Tag actualizado', 'success')
    } else {
      Ctx.flash('Fallo al actualizar el tag', 'danger')
    }
    setLoading(false)
  }

  const isUva = Ctx.context.parent['@name'] === 'uva'

  return (
    <div className="container">
      <hr />
      {isUva && (
        <React.Fragment>
          <hr />
          <Preview url="uvas" id={Ctx.context.id || Ctx.context['@name']} />
        </React.Fragment>
      )}
      <hr />
      <RelatedProducts Ctx={Ctx} />
      <h2 className="title is-size-6">Imágenes</h2>
      <div className="container">
        {isUva ? (
          <Fragment>
            <p>Imágen de la uva</p>
            <ImageEditor
              Ctx={Ctx}
              modifyContent={modifyContent}
              uploadFieldName={'image_grape'}
              field={Ctx.context['api.behaviors.uva.IUvaBehavior'].image_grape}
            />
            <hr />
            <p>Infografia</p>
            <I18NField Widget={Empty}>
              {(lang) => (
                <ImageEditor
                  Ctx={Ctx}
                  modifyContent={modifyContent}
                  uploadFieldName={`image_infograph/${lang}`}
                  field={
                    Ctx.context['api.behaviors.uva.IUvaBehavior']
                      .image_infograph[lang]
                  }
                />
              )}
            </I18NField>
          </Fragment>
        ) : (
          <Fragment>
            <ImageEditor
              Ctx={Ctx}
              modifyContent={modifyContent}
              field={Ctx.context.image_header}
            />
          </Fragment>
        )}
      </div>
      <hr />
      <form onSubmit={onSubmit}>
        <I18NField
          label="Nombre"
          vals={state.localized_text}
          onChange={(values) => {
            if (!isEqual(localized_text, values)) {
              setDirty(true)
            }
            setState({ localized_text: values })
          }}
          modifyContent={modifyContent}
        />
        <I18NRichText
          label="Comentario"
          vals={state.comentario}
          onChange={(values) => {
            if (!isEqual(comentario, values)) {
              setDirty(true)
            }
            setState({ comentario: values })
          }}
          modifyContent={modifyContent}
          editorProps={{ init: TINYMCE_INIT_UNRESTRICTED }}
        />
        <Button
          disabled={!isDirty}
          loading={loading}
          className="is-primary"
          type="submit"
        >
          Guardar
        </Button>
      </form>
    </div>
  )
}

export function RelatedProducts({ Ctx }) {
  const [opened, setOpened] = React.useState(false)
  const [loading, setLoading] = React.useState(true)
  const [products, setProducts] = React.useState([])

  React.useEffect(() => {
    ;(async () => {
      if (opened === false) return
      setLoading(true)
      const result = await Ctx.client.esQuery(
        getTagQuery(Ctx.context['@name'], Ctx.context.parent['@name'])
      )
      const data = await result.json()
      setProducts(data.member)
      setLoading(false)
    })()
  }, [opened])

  return (
    <div className="columns">
      <div className="column is-2">
        <h2 className="title is-size-6">Productos</h2>
        <p className="is-size-7">
          {!opened && (
            <a
              onClick={(ev) => {
                setOpened(!opened)
              }}
            >
              Ver Productos
            </a>
          )}
          {opened && (
            <a
              onClick={(ev) => {
                setOpened(!opened)
              }}
            >
              Productos: {products.length}
            </a>
          )}
        </p>
      </div>
      <div className="column is-10">
        {opened && (
          <div
            className="is-size-6"
            style={{ height: '200px', overflow: 'auto' }}
          >
            {loading && <Loading />}
            {products.length > 0 &&
              products.map((item) => <ProductSummary {...item} />)}
          </div>
        )}
      </div>
    </div>
  )
}

const getTagQuery = (id, category) => ({
  query: {
    bool: {
      filter: [
        { term: { type_name: 'Producto' } },
        {
          nested: {
            path: 'tags',
            query: {
              bool: {
                filter: [
                  { term: { 'tags.id': `${id}` } },
                  { term: { 'tags.category': category } },
                ],
              },
            },
          },
        },
      ],
    },
  },
  _source: ['id', 'path', 'nombre', 'tipo', 'title'],
  size: 200,
})

const props = {
  Buttons: null,
  Panels: <TagPropView />,
}

export default props
